<template>
    <v-layout column>
        <h1>Products</h1>
        <v-data-table
            :headers="headers"
            :items="products"
            :loading="ui.loading"
            :hide-actions="products.length <= 10"
            class="elevation-4 mt-4"
        >
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
              <tr @click="props.expanded = !props.expanded" class="pointer">
                <td>
                    <v-btn icon>
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </td>
                <td>{{ props.item.title }}</td>
                <td>{{ props.item.product_type }}</td>
                <td>{{ props.item.variants.length }}</td>
                <td>{{ props.item.updated_at | toDate }}</td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-flex xs12 sm11 offset-sm1 class="transparent">
              <v-data-table
                  :headers="variant_headers"
                  :items="props.item.variants"
                  :hide-actions="props.item.variants.length <= 5"
                  class="elevation-10 variant-table"
              >
                <template slot="items" slot-scope="props">
                    <td>{{ props.item.title }}</td>
                    <td>{{ props.item.sku }}</td>
                    <td>{{ props.item.weight }}oz</td>
                    <td>${{ props.item.price }}</td>
                    <td>{{props.item.inventory_quantity}}</td>
                    <td>{{ props.item.updated_at | toDate }}</td>
                </template>
              </v-data-table>
              </v-flex>
            </template>
        </v-data-table>  
    </v-layout>
</template>

<script>
import { db } from '@/services/firebase.js'
import moment from 'moment'
export default {
    data () {
        return {
            ui: {
              loading: true
            },
            headers: [
              { text: '', width: 35, sortable: false, align: 'left', value: 'expand' },
              { text: 'Name', align: 'left', value: 'title' },
              { text: 'Product Type', value: 'product_type' },
              { text: 'Variants', value: 'variants' },
              { text: 'Last Updated', value: 'updated_at' }
            ],
            variant_headers: [
              { text: 'Variant', align: 'left', value: 'title' },
              { text: 'SKU', value: 'sku' },
              { text: 'Weight', value: 'weight' },
              { text: 'Price', value: 'price'},
              { text: 'Inventory', value: 'inventory_quantity'},
              { text: 'Last Updated', value: 'updated_at' }
            ],
            products: []
        }
    },
    filters: {
      toDate: function(str){
        return moment(str).format('MM/DD/YY hh:mma')
      }
    },
    computed: {
        isAdmin () {
            return this.$store.getters.isAdmin !== null && this.$store.getters.isAdmin !== undefined
        },
        isManager () {
            return this.$store.getters.isManager !== null && this.$store.getters.isManager !== undefined
        }
    },
    methods: {

    },
    created () {
        var self = this
        db.collection('products').onSnapshot(productsSnapshot => {
            var products = []
            productsSnapshot.forEach(function(doc) {
                products.push(doc.data())
            })
            self.products = products
            self.ui.loading = false
        })
    },
    mounted () {

    }
}
</script>

<style lang="stylus">
</style>